import React from 'react';

import { Slider } from 'antd';

import styled from 'styled-components';

import { getPreferredMetric } from '@libs/NwFeatures';

import { useFeaturesIndex } from '@hooks/API/UseFeatures';

const ConversionSlider = styled(Slider)`
    margin-top: 6px;

    .ant-slider-mark-text {
        font-size: 0.65rem;
        font-weight: bold;
    }

    .ant-slider-track {
        background-color: ${(props) => props.$disabledStyle && 'rgba(0, 0, 0, 0.25) !important'};
    }

    .ant-slider-handle,
    .ant-slider-dot {
        border-color: ${(props) => props.$disabledStyle && 'rgba(0, 0, 0, 0.25) !important'};
    }
`;

const FeaturesRangeSlider = ({ onChange, value, disabled, itemid }) => {
    const featuresIndex = useFeaturesIndex();
    const feature = featuresIndex.featureById.get(itemid);
    const conversion = feature && featuresIndex.conversionById.get(feature.ConversionID);

    const metricToUse = conversion && getPreferredMetric(conversion.ID, featuresIndex);
    const conversionValues = conversion
        ? conversion.ConversionValues.filter((conversionValue) => conversionValue.Metric === metricToUse)
        : [];

    const handleChange = (index) => {
        const val1 = conversionValues[index[0]].Key;
        const val2 = conversionValues[index[1]].Key;
        onChange([val1, val2]);
    };

    const filterValue = (val) => {
        const index1 = conversionValues.findIndex((el) => el.Key === val[0]);
        const index2 = conversionValues.findIndex((el) => el.Key === val[1]);
        return [index1, index2];
    };

    let marks = {};
    const interval = Math.round(conversionValues.length / 10);
    conversionValues.map((conversionValue, index) => {
        if (
            (index % interval === 0 && conversionValues.length - index >= interval) ||
            index === conversionValues.length - 1
        ) {
            marks = {
                ...marks,
                [index]: conversionValue.Value,
            };
        }
        return null;
    });

    return (
        conversionValues.length > 0 && (
            <ConversionSlider
                min={0}
                range
                marks={marks}
                max={conversionValues.length - 1}
                getTooltipPopupContainer={(triggerNode) => triggerNode.parentNode}
                style={{ width: '100%' }}
                value={filterValue(value)}
                onChange={handleChange}
                disabled={disabled}
                $disabledStyle={disabled}
                tooltipVisible
                tipFormatter={(value) => `${conversionValues[value].Value} ${metricToUse}`}
            />
        )
    );
};

export default FeaturesRangeSlider;
